import React, { useRef, useState, useEffect } from 'react';
import { FaFileSignature, FaSave, FaSyncAlt, FaPhotoVideo } from 'react-icons/fa';
import './formulario.css';
import API from "../../providers/api";
import { Row, Col, Card, CardBody, Spinner, Input, FormGroup, Label } from "reactstrap"
import SignatureCanvas from 'react-signature-canvas'
import logo from '../../assets/img/logo.jpg'
import logo_enterate from '../../assets/img/logo_enterate.jpg'
import success from '../../assets/img/success.png'
import fail from '../../assets/img/fail.png'
import warning from '../../assets/img/warning.png'
import { alert } from '../../helpers/alert';
import Webcam from 'react-webcam'
import moment from 'moment'

const Formulario = () => {
    const formatCash = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });
    /* const WebcamComponent = () => <Webcam />
    const videoConstraints = {
        width: 400,
        height: 225,
        facingMode: 'user',
    } */

    const [picture, setPicture] = useState('')
/*     const webcamRef = React.useRef(null)
    const capture = React.useCallback(() => {
        const pictureSrc = webcamRef.current.getScreenshot()
        setPicture(pictureSrc)
    }) */
    const [ip, setIp] = useState('0.0.0.0')
    const [token, setToken] = useState('')
    const [viewForm, setViewForm] = useState(false)
    const [viewSign, setViewSign] = useState(true)
    const [applicant, setApplicant] = useState('')
    const [applicantSignature, setApplicantSignature] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [sign, setSign] = useState('')
    const [signA, setSignA] = useState('')
    const [url, setUrl] = useState('')
    const [urlA, setUrlA] = useState('')
    const [agentName, setAgentName] = useState('-')
    const [agentNumber, setAgentNumber] = useState('-')
    const [agentPhone, setAgentPhone] = useState('-')
    const [agentEmail, setAgentEmail] = useState('-')
    const [loadingSave, setLoadingSave] = useState(false)
    const [resultSuccess, setResultSuccess] = useState(true)
    const [loadingInit, setLoadingInit] = useState(false)
    const [formSend, setFormSend] = useState(false)
    const [typeSignature, setTypeSignature] = useState(2)
    const [emailReceives, setEmailReceives] = useState('');
    const [canvasMaker, setCanvasMaker] = useState(null);
    const [validateSignature, setValidateSignature] = useState(false);
    const [btnValSignature, setBtnValSignature] = useState(true);
    const [btnGetSignature, setBtnGetSignature] = useState(false);
    const [btnCamare, setBtnCamare] = useState(false);
    const [btnSave, setBtnSave] = useState(false);
    const [canvasArea, setCanvasArea] = useState(true);
    const [format, setFormat] = useState(true);
    const [maritalStatus, setMaritalstatus] = useState('');
    const [totalAnual, setTotalAnual] = useState(0);
    const [totalDependent, setTotalDependent] = useState(0);
    const [totalMedicare, setTotalMedicare] = useState(0);
    const [stateSwitch, setStateSwitch] = useState(true);
    const [taxes, setTaxes] = useState('');
    const [company, setCompany] = useState('');
    const [plan, setPlan] = useState('');
    const [price, setPrice] = useState('');
    const [deductible, setDeductible] = useState('');
    const [deductibleDrug, setDeductibleDrug] = useState('');
    const [gd, setGD] = useState('');
    const [pd, setPD] = useState('');
    const [sd, setSD] = useState('');

    const viewButtonSign =  false
    const dateExpiration = moment().add(1, 'year').format('MM/DD/YYYY')
    let canvasVal = null;
    let contextVal = null;
    const canvasSurface = useRef(null)
    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        const token = queryParameters.get("token")
        if(token != undefined){
            setToken(token)
            API.validateForm(token)
            .then(data => data.json())
            .then(dataJson => {
                if (dataJson.success == true) {
                    const info = dataJson.data
                    if(info.validateForm != ''){
                        if(info.validateFormat == 'enterate'){
                            setFormat(info.validateFormat)
                            setMaritalstatus(info.maritalStatus)
                            setTotalAnual(info.totalanual)
                            setTotalDependent(info.totalDependent)
                            setTotalMedicare(info.totalMedicare)
                            setTaxes(info.totalanual)
                            setCompany(info.company)
                            setPlan(info.plan)
                            setPrice(info.monthly)
                            setDeductible(info.deductible)
                            setDeductibleDrug(info.deductible_drug)
                            setGD(info.gd)
                            setPD(info.pd)
                            setSD(info.sd)
                        }
                    }
                    if(info.datecreate == null){
                        setApplicant(info.applicant)
                        setApplicantSignature(info.applicantcap)
                        setPhone(info.phone1)
                        setEmail(info.email)
                        setAgentName(info.agent)
                        setAgentNumber(info.npn)
                        setAgentPhone(info.phoneagent)
                        setAgentEmail(info.emailagent)
                        setEmailReceives(info.email_receives)
                        setTaxes(info.totalanual)
                        setCompany(info.company)
                        setPlan(info.plan)
                        setPrice(info.monthly)
                        setDeductible(info.deductible)
                        setDeductibleDrug(info.deductible_drug)
                        setGD(info.gd)
                        setPD(info.pd)
                        setSD(info.sd)
                        setViewForm(true)
                        setFormSend(true)
                        canvasVal = canvasSurface.current;
                        console.log(canvasSurface, "canvasSurface");
                        console.log(canvasVal, "canvasVal");
                        setCanvasMaker(canvasVal)
                        styleCanvas(info.applicantcap)
                        canvasVal.width=canvasVal.width

                        fetch(process.env.REACT_APP_API_IP)
                        .then(response => response.json())
                        .then(data => {
                            console.log(data.ip);
                            setIp(data.ip)
                        });
                    }else{
                        setViewForm(false)
                        setResultSuccess(true)
                        setLoadingInit(true)
                        setFormSend(false)
                        alert('Warning!', `This information has already been processed on the day ${moment(info.datecreate).format('MM-DD-YYYY')}`, 'warning', 'Closed');
                    }
                }else{
                    setViewForm(false)
                    setLoadingInit(true)
                    setResultSuccess(false)
                    setFormSend(false)
                }
            })
            .catch((e) => {
                console.log("Error =>", e)
            })
        }
    }, [])

    const styleCanvas = (applicantcap) => {
        if(canvasVal != null)
        {
            contextVal = canvasVal.getContext("2d");
            contextVal.fillStyle = "#000";
            contextVal.font = "50px Stalemate";
            contextVal.fillText(applicantcap, 40, 50);
            setSignA(canvasVal)
        }else{
            contextVal = canvasMaker.getContext("2d");
            contextVal.fillStyle = "#000";
            contextVal.font = "50px Stalemate";
            contextVal.fillText(applicantcap, 40, 50);
            setSignA(canvasMaker)
        }
    }

    const styleTryCanvas = () => {
        setValidateSignature(true)
        canvasMaker.width=canvasMaker.width
        styleCanvas(applicantSignature)
        setBtnValSignature(false)
        setBtnGetSignature(true)
        //setBtnCamare(false)
        setBtnSave(false)
    }

    const handleClear = () => {
        sign.clear()
        setUrl('')
    }

    const handleGenerate = () => {
        setUrl(sign.getTrimmedCanvas().toDataURL('image/png'))
        setUrlA('')
    }

    const handleGenerateA = () => {
        if(!validateSignature)
            alert('Warning!', 'Validate your signature.', 'warning', 'Closed');
        setUrl('')
        setUrlA(signA.toDataURL('image/png'))
        setBtnValSignature(false)
        setBtnGetSignature(false)
        setCanvasArea(false)
        //setBtnCamare(true)
        setBtnSave(true)
    }

    const handleSign = () => {
        setViewSign(!viewSign)
    }

    const handleSave = () => {
        if(!validateSignature)
            return alert('Warning!', 'Validate your signature.', 'warning', 'Closed');
        if(url == "" && urlA == "")
            return alert('Warning!', 'Empty signature.', 'warning', 'Closed');
        setLoadingSave(true)
        API.saveForm(token, url != "" ? url : urlA != "" ? urlA : '', applicant, agentName, agentNumber, agentPhone, agentEmail, "-", "-", "-", "-", "-", emailReceives, picture != "" && picture != undefined ? picture : '-', ip, stateSwitch)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success == true) {
                setViewForm(false)
                alert('Success!', dataJson.message, 'success', 'Closed');
                setBtnValSignature(false)
                setBtnGetSignature(false)
                setBtnSave(false)
            }else{
                alert('Warning!', dataJson.message, 'warning', 'Closed');
            }
            setLoadingSave(false)
        })
        .catch((e) => {
            console.log("Error =>", e)
        })
    }

    const onchangeTypeSignature = (e) => {
        const value = e.target.value
        setTypeSignature(value)
        if(value == "1"){
            setUrl('')
        }
    }

    return (
        <div className='flex-container'>
            <div>
                <Card style={{ opacity: '0.9' }}>
                    {
                        viewForm ?
                            <CardBody>
                                <div className='row'>
                                    <div className='col-lg-1'></div>
                                    <div className='col-lg-10 text-center'>
                                        <a href="#">
                                            {
                                                format == 'enterate' ?
                                                    <img style={{width:'100%',maxWidth:'300px'}} src={logo_enterate} className='logoWidth' />
                                                :
                                                    <img style={{width:'100%',maxWidth:'300px'}} src={logo} className='logoWidth' />
                                            }
                                        </a>
                                    </div>
                                    <div className='col-lg-1'></div>
                                </div>
                                {
                                    format == 'enterate' ?
                                    <>
                                        <div className='row mb-3'>
                                            <div className='col-lg-6'>
                                                Today's Date: <u style={{fontWeight:'bold'}}>{moment().format('MM/DD/YYYY')}</u>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                            I, Mr. /Ms. <u style={{fontWeight:'bold'}}>{applicant}</u>, have given consent to the below
                                            agent(s)/Entities on the date of <u style={{fontWeight:'bold'}}>{moment().format('MM/DD/YYYY')}</u> prior to the enrollment of my application for health insurance through the Health Insurance Marketplace. I have provided information necessary to be
                                            eligible for the tax credit granted by the Health Insurance Marketplace and thus obtain benefits of a reduced
                                            premium. I certify that I have received and understand the advice provided by:
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12'>
                                                Agents and/or Entities: <u style={{fontWeight:'bold'}}>{agentName}</u><br/>
                                                NPN: <u style={{fontWeight:'bold'}}>{agentNumber}</u>
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                I hereby give my permission to the agents and entities specified above to act as health insurance agent or broker
                                                for me and my entire household, if applicable. By consenting to this agreement, I authorize you to view and use
                                                the confidential information provided by me in writing, electronically, or by telephone only for the purposes of
                                                one or more of the following:

                                                <ol className='mt-3' style={{textAlign:'justify'}}>
                                                    <li>Search and/or creation of an application in the Insurance Market;</li>
                                                    <li>Complete an application for eligibility and enrollment in a Marketplace Qualified Health Plan or other
                                                    government insurance affordability programs, such as Medicaid and CHIP or advance tax credits to help pay
                                                    Marketplace premiums;</li>
                                                    <li>Provide ongoing account maintenance and enrollment assistance, as needed; either</li>
                                                    <li>Respond to Marketplace inquiries regarding my Marketplace application.</li>
                                                </ol>
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                I understand that my consent remains in effect until I revoke it, and I may revoke or modify my consent at any
                                                time by contacting the authorized agents and entities to receive acknowledgment that consent has been
                                                rescinded.
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                I have reviewed all the required information and understand the attestations presented before the submission
                                                of my application. Likewise, I understand that in case of changes in the data provided below or any others, I
                                                must notify my representative immediately to update my application.
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                <ul>
                                                    <li>Marital status: <u style={{fontWeight:'bold'}}>{maritalStatus == 'm' ? 'MARRIED' : 'SINGLE'}</u></li>
                                                    <li>Projected Annual Family Income: <u style={{fontWeight:'bold'}}>{totalAnual}</u></li>
                                                    <li>Number of people on your {moment().format('YYYY')} tax return: <u style={{fontWeight:'bold'}}>{totalDependent}</u></li>
                                                    <li>People with medical coverage: <u style={{fontWeight:'bold'}}>{totalMedicare}</u></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                I confirm that I have NO other medical insurance, as well as that I have no offer in my job of medical coverage.
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12' style={{textAlign:'justify'}}>
                                                I am signing this consent under penalty of perjury, which means that I have provided true answers to all
                                                questions to the best of my knowledge. I know that I may be subject to penalties under federal law if I
                                                intentionally provide false information.
                                            </div>
                                        </div>
                                        <div className='row mt-3'>
                                            <div className='col-lg-12 text-center'>
                                                <div className='row'>
                                                    <div className='col-lg-4'>
                                                        <br/><br/>
                                                        {applicant}<br/>
                                                        ____________________________________<br/>
                                                        <b>Full name</b>
                                                    </div>
                                                    <div className='col-lg-4'>
                                                        <img src={url != "" ? url : urlA != "" ? urlA : ''} style={{width:'100%'}} />
                                                        _____________________________________________<br/>
                                                        <b>Signature</b>
                                                    </div>
                                                    <div className='col-lg-4'>
                                                        <br/><br/>
                                                        {moment().format('MM/DD/YYYY')}<br/>
                                                        ___________________________________<br/>
                                                        <b>Date of signature</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    ://CMS
                                    <>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-8'></div>
                                            <div className='col-lg-3'><b>Expiration Date:</b> {dateExpiration}</div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-10'>
                                                <b>Legal Disclosure:</b>
                                                <p style={{fontStyle:'italic',textAlign:'justify'}}>
                                                The contents of this document do not have the force and effect of law and are not meant to bind the public in
                                                any way, unless specifically incorporated into a contract. This document is intended only to provide clarity to the
                                                public regarding existing requirements under the law. This model consent form will not supersede any State
                                                Agent of Record, Broker of Record, or other form required by a QHP issuer for purposes of making commission
                                                payments to the proper agent or broker for assisting a particular consumer.
                                                </p>
                                                <b>Purpose Statement:</b>
                                                <p style={{textAlign:'justify'}}>
                                                Registered agents and brokers assisting consumers apply for and enroll in Marketplace coverage must document
                                                consumer consent prior to accessing or updating their Marketplace information. CMS does not prescribe the
                                                manner in which agents and brokers must document consent. Instead, there are different formats that may be
                                                acceptable for agents and brokers to use to document consumer consent, such as via a recorded phone call, text
                                                message, email, electronic document with digital signatures, physical document with wet signatures, etc. This
                                                model consent form serves as an example for how agents and brokers may document consent via a physical
                                                document with wet signatures.
                                                </p>
                                                <p style={{textAlign:'justify'}}>
                                                Since this model consent form is a best practice for obtaining consumer consent, you may tailor the form to
                                                address the needs of your specific business model in addition to meeting the CMS requirement to document
                                                consent from a consumer prior to assisting the consumer enroll in coverage in the Marketplace, including prior
                                                to conducting a person search. For example, if an Agency is involved, you may clarify specifically who else within
                                                the Agency other than the writing Agent is able to view and use the consumer’s PII to assist the writing Agent in
                                                enrolling the consumer in Marketplace coverage for compliance, commissions, or other relevant purposes as
                                                you see fit.
                                                </p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-10 text-center'>
                                                <b>CMS Model Consent Form for Marketplace Agents and Brokers</b>
                                            </div>
                                            <div className='col-lg-1'></div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-10'>
                                                <p style={{textAlign:'justify'}}>
                                                I, <b style={{textDecoration:'underline'}}>{applicant}</b>, give my permission to <b style={{textDecoration:'underline'}}>{agentName}</b> to serve as the
                                                health insurance agent or broker for myself and my entire household if applicable, for purposes of enrollment in
                                                a Qualified Health Plan offered on the Federally Facilitated Marketplace. By consenting to this agreement, I
                                                authorize the above-mentioned Agent to view and use the confidential information provided by me in writing,
                                                electronically, or by telephone only for the purposes of one or more of the following:
                                                </p>
                                                <p style={{textAlign:'justify'}}>
                                                    <ol>
                                                        <li>Searching for an existing Marketplace application;</li>
                                                        <li>Completing an application for eligibility and enrollment in a Marketplace Qualified Health Plan or other
                                                            government insurance affordability programs, such as Medicaid and CHIP or advance tax credits to help
                                                            pay for Marketplace premiums;</li>
                                                        <li>Providing ongoing account maintenance and enrollment assistance, as necessary; or</li>
                                                        <li>Responding to inquiries from the Marketplace regarding my Marketplace application.</li>
                                                    </ol>
                                                </p>
                                                <p style={{textAlign:'justify'}}>
                                                I understand that the Agent will not use or share my personally identifiable information (PII) for any purposes
                                                other than those listed above. The Agent will ensure that my PII is kept private and safe when collecting, storing,
                                                and using my PII for the stated purposes above.
                                                </p>
                                                <p style={{textAlign:'justify'}}>
                                                I confirm that the information I provide for entry on my Marketplace eligibility and enrollment application will
                                                be true to the best of my knowledge. I understand that I do not have to share additional personal information
                                                about myself or my health with my Agent beyond what is required on the application for eligibility and
                                                enrollment purposes. I understand that my consent remains in effect until I revoke it, and I may revoke or
                                                modify my consent at any time by <b style={{textDecoration:'underline'}}>{applicant}</b>
                                                </p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                        </div>
                                        <div className='row'>
                                        <div className='col-lg-1'></div>
                                        <div className='col-lg-10'>
                                            <div>
                                                <table style={{width:'100%'}}>
                                                    <tr>
                                                        <td>Name of Primary Writing Agent:</td><td style={{fontWeight:'bold'}}>{agentName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Agent National Producer Number: </td><td style={{fontWeight:'bold'}}>{agentNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Phone Number: </td><td style={{fontWeight:'bold'}}>{agentPhone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email Address: </td><td style={{fontWeight:'bold'}}>{agentEmail}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div>
                                                <table style={{width:'100%'}}>
                                                    <tr>
                                                        <td>Name of Primary Household Contact<br/>
                                                        and/or Authorized Representative:  </td><td style={{fontWeight:'bold'}}>{applicant}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Phone Number: </td><td style={{fontWeight:'bold'}}>{phone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email Address: </td><td style={{fontWeight:'bold'}}>{email}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Taxes: </td><td style={{fontWeight:'bold'}}>{formatCash.format(taxes)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Company: </td><td style={{fontWeight:'bold'}}>{company}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Plan: </td><td style={{fontWeight:'bold'}}>{plan}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Monthly pay: </td><td style={{fontWeight:'bold'}}>{price}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Health Deductible: </td><td style={{fontWeight:'bold'}}>{deductible}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Drug Deductible: </td><td style={{fontWeight:'bold'}}>{deductibleDrug}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Generic drugs (GD): </td><td style={{fontWeight:'bold'}}>{gd}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Doctor visits (PD): </td><td style={{fontWeight:'bold'}}>{pd}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Specialist visits (SD): </td><td style={{fontWeight:'bold'}}>{sd}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date: </td><td style={{fontWeight:'bold'}}>{moment().format('MM-DD-YYYY')}</td>
                                                    </tr>
                                                </table>
                                                <table>
                                                    <tr>
                                                        <td>Signature:  </td><td>
                                                            <img src={url != "" ? url : urlA != "" ? urlA : ''} style={{width:'100%'}} />
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div className='col-lg-1'></div>
                                        </div>
                                    </>
                                }
                                <div className='row'>
                                    <div className='col-lg-1'></div>
                                    <div className='col-lg-10'>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-10 text-center'>
                                                {
                                                    viewButtonSign ?
                                                        <button className='btn btn-primary' onClick={handleSign}>Signature</button>
                                                    : ''
                                                }
                                            </div>
                                            <div className='col-lg-1'></div>
                                        </div>
                                        <br/>
                                        <div className='row' style={{display:'none'}}>
                                            <div className='col-lg-2'></div>
                                            <div className='col-lg-8 text-center'>
                                                <label>Type signature</label>
                                                <select className='form-control' value={typeSignature} onChange={e => onchangeTypeSignature(e)} disabled>
                                                    <option value="">Select</option>
                                                    <option value="1">Manuscript</option>
                                                    <option value="2">Automatic</option>
                                                </select>
                                            </div>
                                            <div className='col-lg-2'></div>
                                        </div>
                                        <br/>
                                        {
                                            typeSignature == "2" ?
                                                <>
                                                    <div className='row'>
                                                        <div className='col-lg-1'></div>
                                                        <div className='col-lg-10 text-center'>
                                                            { canvasArea ? <canvas width='600' ref={canvasSurface} height='100'></canvas>:''}
                                                        </div>
                                                        <div className='col-lg-1'></div>
                                                    </div>
                                                    <br/>
                                                    <div className='row'>
                                                        <div className='col-lg-1'></div>
                                                        <div className='col-lg-10 text-center'>
                                                            {
                                                                btnValSignature ?
                                                                <>
                                                                    <label style={{fontWeight:'bold'}}>Step 1: </label><br/>
                                                                    <button className='btn btn-primary' onClick={styleTryCanvas}> <FaFileSignature size={15} /> Validate Signature</button>
                                                                </> : ''
                                                            }
                                                        </div>
                                                        <div className='col-lg-1'></div>
                                                    </div>
                                                    <br/>
                                                    <div className='row'>
                                                        <div className='col-lg-1'></div>
                                                        <div className='col-lg-10 text-center'>
                                                            {
                                                                btnGetSignature ?
                                                                <>
                                                                    <label style={{fontWeight:'bold'}}>Step 2: </label><br/>
                                                                    <button className='btn btn-danger' onClick={handleGenerateA}><FaFileSignature size={15} /> Get Signature</button>
                                                                </> : ''}
                                                        </div>
                                                        <div className='col-lg-1'></div>
                                                    </div>
                                                    {
                                                        /* btnCamare ?
                                                            <Row>
                                                                <Col lg="3"></Col>
                                                                <Col lg="6">
                                                                    <label style={{fontWeight:'bold'}}>Step 3: My photo</label>
                                                                    {picture == '' ? (
                                                                        <Webcam
                                                                            audio={false}
                                                                            height={225}
                                                                            ref={webcamRef}
                                                                            width="100%"
                                                                            screenshotFormat="image/jpeg"
                                                                            videoConstraints={videoConstraints}
                                                                        />
                                                                        ) : (
                                                                        <img src={picture} style={{width:'100%'}} />
                                                                    )}
                                                                    {picture != '' ? (
                                                                        <button
                                                                            onClick={(e) => {
                                                                            e.preventDefault()
                                                                            setPicture('')
                                                                            }}
                                                                            className="btn btn-primary"
                                                                        >
                                                                            Try again <FaSyncAlt size={15} />
                                                                        </button>
                                                                        ) : (
                                                                        <button
                                                                            onClick={(e) => {
                                                                            e.preventDefault()
                                                                            capture()
                                                                            }}
                                                                            className="btn btn-danger"
                                                                        >
                                                                            Get photo <FaPhotoVideo size={20} />
                                                                        </button>
                                                                    )}
                                                                </Col>
                                                                <Col lg="3"></Col>
                                                            </Row>
                                                        : '' */
                                                    }
                                                </>
                                            : typeSignature == "1" ?
                                                viewSign ?
                                                    <>
                                                        <br/>
                                                        <div className='row text-center'>
                                                            <div className='col-lg-1'></div>
                                                            <div className='col-lg-10' style={{border:'2px solid black',width:800, height:300}}>
                                                                <label>Type your signature in the box</label>
                                                                <SignatureCanvas canvasProps={{width:800, height:300, className: 'sigCanvas'}} ref={data=>setSign(data)} />
                                                            </div>
                                                            <div className='col-lg-1'></div>
                                                        </div>
                                                        <br/>
                                                        <div className='row'>
                                                            <div className='col-lg-1'></div>
                                                            <div className='col-lg-10 text-center'>
                                                                <button className='btn btn-dark' onClick={handleClear}>Clear</button>
                                                                <button className='btn btn-danger' onClick={handleGenerate}>Get Signature</button>
                                                            </div>
                                                            <div className='col-lg-1'></div>
                                                        </div>
                                                    </>
                                                : ''
                                            : ''
                                        }
                                        <br/>
                                        <div className='row'>
                                            <div className='col-lg-2'></div>
                                            <div className='col-lg-10'>
                                            <FormGroup switch style={{paddingLeft:'4.5em'}}>
                                                <Input
                                                type="switch"
                                                checked={stateSwitch}
                                                onClick={() => {
                                                    setStateSwitch(!stateSwitch);
                                                }}
                                                />
                                                <Label check>Checked switch gets IP Public, this will allow its IP to be stored in our system</Label>
                                            </FormGroup>
                                            </div>
                                            <div className='col-lg-2'></div>
                                        </div>
                                        <br/>
                                        <div className='row'>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-10 text-center'>
                                                {
                                                    loadingSave ?
                                                        <><Spinner color='success' /><br/><b style={{color:'#198564'}}>Send data... Please wait.</b></>
                                                        : btnSave ?
                                                            <>
                                                                <label style={{fontWeight:'bold'}}>Step 3: </label><br/>
                                                                <button className='btn btn-success' onClick={handleSave}><FaSave size={15} /> Save</button>
                                                            </> : ''
                                                }
                                            </div>
                                            <div className='col-lg-1'></div>
                                        </div>
                                        {
                                            format == 'enterate' ? ''
                                            :
                                            <p className='mt-4' style={{fontSize:'9pt',textAlign:'justify'}}>
                                                <b>PRA DISCLOSURE: </b>  According to the Paperwork Reduction Act of 1995, no persons are required to respond to a collection of information unless it displays a
                                                valid OMB control number. Expiration date is {dateExpiration}. The time required
                                                to complete this information collection is estimated to take up to 0.08 hours per applicant per year, including the time to review instructions, gather the
                                                information needed, and complete and review the information collection. If you have comments concerning the accuracy of the time estimate(s) or
                                                suggestions for improving this form, please write to: CMS, 7500 Security Boulevard, Attn: PRA Reports Clearance Officer, Mail Stop C4-26-05, Baltimore,
                                                Maryland 21244-1850. ****CMS Disclosure**** Please do not send applications, claims, payments, medical records or any documents containing
                                                sensitive information to the PRA Reports Clearance Office. Please note that any correspondence not pertaining to the information collection burden
                                                approved under the associated OMB control number listed on this form will not be reviewed, forwarded, or retained. If you have questions or concerns
                                                regarding where to submit your documents, please contact Brian Gubin at Brian.Gubin@cms.hhs.gov.
                                            </p>
                                        }
                                    </div>
                                    <div className='col-lg-1'></div>
                                </div>
                            </CardBody>
                        :<div className='row mt-4'>
                            <div className='col-lg-1'></div>
                            <div className='col-lg-10 text-center'>
                                <div className='row'>
                                    <div className='col-lg-1'></div>
                                    <div className='col-lg-10 text-center'>
                                        <a href="#">
                                            {
                                                format == 'enterate' ?
                                                    <img style={{width:'100%',maxWidth:'300px'}} src={logo_enterate} className='logoWidth' />
                                                :
                                                    <img style={{width:'100%',maxWidth:'300px'}} src={logo} className='logoWidth' />
                                            }
                                        </a>
                                    </div>
                                    <div className='col-lg-1'></div>
                                </div>
                                {
                                    loadingInit ?
                                        resultSuccess ?
                                            <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={warning} style={{width:'20%'}} /><br/>This information has already been processed</p>
                                        : <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={fail} style={{width:'20%'}} /><br/>No was possible the processing</p>
                                    : formSend ?
                                            <p style={{fontSize:'14pt',fontWeight:'bold'}}><img src={success} style={{width:'20%'}} /><br/>Data proccessed successfully</p>
                                        : <Spinner color="success" />
                                }
                            </div>
                            <div className='col-lg-1'></div>
                        </div>
                    }
                </Card>
            </div>
        </div>
    );
}

export default Formulario;